export class Configurations {
  public env: any;

  constructor(
  ) {
    this.env = {};
  }
}
